import React from 'react';
import classes from './InstitutionIdCell.module.css';

const InstitutionIdCell = ({ value }) => {

  return (
    <div className={classes.institutionIdCell}>
      {String(value)}
    </div>
  );
};

export default InstitutionIdCell;
